import styled from 'styled-components';

import { grid } from '../../Styles';
import { IGridProps } from './Grid.types';

export const Grid = styled.div`
  ${grid}
  ${(props: IGridProps) => {
    const { minColWidth } = props;
    return (
      minColWidth && `grid-template-columns:repeat(auto-fill,minmax(${minColWidth}${typeof minColWidth == 'number' ? 'px' : ''}, 1fr));`
    );
  }}
`;
